export default "__VITE_PUBLIC_ASSET__10a752fe__"